import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';

const WheelchairAssessment = {
  ID: 29,
  Name: 'Wheelchair Assessment',
  Type: 'Assessment Form',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Wheelchair-Assessment/1.js',
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          multiline: true,
          x: 49,
          y: 27,
          width: 62,
          height: 8,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 49,
          y: 35,
          width: 62,
          height: 8,
          multiline: true,
        },
        {
          name: 'Patient Phone',
          type: 'text',
          getValue: getPatientFullPhone,
          x: 49,
          y: 43,
          width: 62,
          height: 8,
          multiline: true,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Wheelchair Specifications',
          type: 'text',
          x: 120,
          y: 35,
          width: 79,
          height: 16,
          multiline: true,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 37,
          y: 58,
          width: 12,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 103,
          y: 58,
          width: 12,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Shoulder Width',
          type: 'text',
          x: 103,
          y: 71,
          width: 40,
        },
        {
          name: 'Chest Width',
          type: 'text',
          x: 103,
          y: 79,
          width: 40,
        },
        {
          name: 'Hip Width',
          type: 'text',
          x: 103,
          y: 87,
          width: 40,
        },
        {
          name: 'Width at Knee',
          type: 'text',
          x: 103,
          y: 95,
          width: 40,
        },
        {
          name: 'Seat to Top of Head',
          type: 'text',
          x: 103,
          y: 103,
          width: 40,
        },
        {
          name: 'Seat to Top of Shoulder (L, R)',
          type: 'text',
          x: 103,
          y: 111,
          width: 40,
        },
        {
          name: 'Seat to Axilla (L, R) Armpit',
          type: 'text',
          x: 103,
          y: 119,
          width: 40,
        },
        {
          name: 'Chest Depth(L, R) Back to Tip of Chest',
          type: 'text',
          x: 103,
          y: 127,
          width: 40,
        },
        {
          name: 'Seat Depth (L, R) Actual',
          type: 'text',
          x: 103,
          y: 135,
          width: 40,
        },
        {
          name: 'Seat to Footplate',
          type: 'text',
          x: 103,
          y: 143,
          width: 40,
        },
        {
          name: 'Shoulder Width',
          type: 'text',
          x: 173,
          y: 183,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Chest Width',
          type: 'text',
          x: 173,
          y: 196,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Hip Width',
          type: 'text',
          x: 173,
          y: 210,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Width at Knee',
          type: 'text',
          x: 172,
          y: 228,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Seat to Top of Head',
          type: 'text',
          x: 20,
          y: 164,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Seat to Top of Shoulder (L, R)',
          type: 'text',
          x: 26,
          y: 193,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Seat to Axilla (L, R) Armpit',
          type: 'text',
          x: 35,
          y: 204.5,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Chest Depth(L, R) Back to Tip of Chest',
          type: 'text',
          x: 57,
          y: 196,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Seat Depth (L, R) Actual',
          type: 'text',
          x: 64,
          y: 244,
          width: 8,
          height: 8,
          multiline: true,
        },
        {
          name: 'Seat to Footplate',
          type: 'text',
          x: 81,
          y: 252,
          width: 8,
          height: 8,
          multiline: true,
        },
      ],
    },
  ],
};

export default WheelchairAssessment;



// WEBPACK FOOTER //
// ./src/config/documents/Wheelchair-Assessment.js